import { Box, Typography, LinearProgress } from "@mui/material";

const StepProgress = ({ currentStep = 1, totalSteps = 4, stepLabels = [] }) => {
  const progressValue =
    currentStep > 1 ? ((currentStep - 1) / (totalSteps - 1)) * 100 : 0;
  console.log('progressValue :', progressValue);

  const stepLabel = stepLabels[currentStep - 1] || "";
  console.log('stepLabel :', stepLabel);

  return (
    <Box>
      <Typography variant="body2" mb={1}>
        Step {currentStep} of {totalSteps}
      </Typography>

      <LinearProgress
        variant="determinate"
        value={progressValue}
        sx={{
          height: 20,
          borderRadius: 8,
          backgroundColor: "#f0f2f5",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#1976d2",
          },
        }}
      />

      {stepLabel && (
        <Typography
          variant="caption"
          display="block"
          align="right"
          mt={1}
          color="text.secondary"
        >
          {stepLabel}
        </Typography>
      )}
    </Box>
  );
};

export default StepProgress;
